import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const base_url = process.env.REACT_APP_API_URL;

export default function UserNavbar({ toggleSidebar }) {
  const token = localStorage.getItem("token");
  const [logged, setLogged] = useState(false);
  const [balance, setBalance] = useState(0);
  const [user, setUser] = useState(null);
  const [myInviteCode, setInviteCode] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      setLogged(true);
      fetchUserData();
    }

    // listen wallet update
    const handleWalletUpdate = () => {
      if (token) fetchUserData();
    };

    window.addEventListener("walletUpdated", handleWalletUpdate);

    return () => {
      window.removeEventListener("walletUpdated", handleWalletUpdate);
    };
  }, []);

  useEffect(() => {
    if (token) {
      setLogged(true);
      fetchUserData();
    }
  }, []);

  const fetchUserData = async () => {
    try {
      const res = await axios.get(base_url + "/api/webapi/userInfo", {
        headers: {
          Authorization: `${token}`,
        },
      });

      if (res.data.status) {
        setUser(res.data.data);
        setBalance(parseFloat(res.data.data.money).toFixed(2) || 0);
        setInviteCode(res.data.data.code);
      }
    } catch (err) {
      console.log(err);
      // logout();
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  const handleShareInvite = async () => {
    const inviteCode = myInviteCode;

    if (!inviteCode) {
      toast.info("Invite code not found");
      return;
    }

    const url = `${window.location.origin}/login?mode=signup&invite=${inviteCode}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "Join me",
          url,
        });
      } else {
        await navigator.clipboard.writeText(url);
        toast.info("Invite link copied!");
      }
    } catch (err) {
      // ✅ Ignore cancel error
      if (err.name === "AbortError") {
        console.log("User cancelled share");
      } else {
        console.error(err);
        toast.info("Something went wrong");
      }
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between px-3 py-2"
      style={{
        background: "linear-gradient(90deg,#7f7fd5,#ff7e30)",
        color: "#fff",
      }}
    >
      {/* LEFT */}
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn text-white btn-sm d-lg-none p-0"
          style={{ fontSize: "20px" }}
          onClick={toggleSidebar}
        >
          <i className="bi bi-list"></i>
        </button>

        <img
          style={{ cursor: "pointer" }}
          src="/logo.png"
          height="40"
          alt="logo"
          className="rounded-circle"
          onClick={() => navigate("/")}
        />
      </div>

      {/* RIGHT */}
      {!logged ? (
        <div className="d-flex gap-2">
          <Link to="/login" className="btn btn-light btn-sm">
            LOG IN
          </Link>
          <Link to="/login?mode=signup" className="btn btn-dark btn-sm">
            SIGN UP
          </Link>
        </div>
      ) : (
        <div className="d-flex align-items-center gap-3">
          {/* WALLET */}
          <div className="wallet-chip">💰 {balance}</div>

          {/* PROFILE DROPDOWN */}
          <div className="dropdown">
            <button className="btn profile-btn" data-bs-toggle="dropdown">
              <img
                src="/avatar.png"
                width="34"
                height="34"
                className="rounded-circle"
                alt="profile"
              />
            </button>

            <ul className="dropdown-menu dropdown-menu-end profile-dropdown">
              <li className="dropdown-item-text">UID: {user?.id_user}</li>

              <li>
                <hr />
              </li>

              <li>
                <Link className="dropdown-item" to="/deposit">
                  💳 Deposit
                </Link>
              </li>

              <li>
                <Link className="dropdown-item" to="/withdraw">
                  💸 Withdraw
                </Link>
              </li>

              <li>
                <Link className="dropdown-item" to="/history">
                  📜 History
                </Link>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation(); // ✅ prevent dropdown close
                    handleShareInvite();
                  }}
                >
                  👥 Share Invite Code
                </button>
              </li>

              <li>
                <hr />
              </li>

              <li>
                <button className="dropdown-item text-danger" onClick={logout}>
                  🚪 Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
